<template>
  <div id="root_box">
    <div class="pic-box">
      <el-image class="pic" v-for="(pic, index) in pics" :src="pic" :key="index">
        <div slot="error" class="image-slot"></div>
      </el-image>
    </div>
    <div class="absolute-box">
      <div class="card">
        <div class="row-1">
          <div class="point"></div>
          <div class="point"></div>
        </div>
        <div class="row-2">
          <span class="text">邀请码 </span>
          <div class="code-box">
            <div class="code">{{code}}</div>
            <div class="line"></div>
            <div class="code absolute">{{code}}</div>
          </div>
        </div>
        <div class="row-3" v-if="datad">
          <el-image class="avatar"
            :src="avatar">
            <div slot="error" class="image-slot"></div>
          </el-image>
          <div v-if="textType == 1" class="row-2" style="margin-bottom: 0px">
            <span class="text">我已打卡学习 </span>
            <div class="code-box">
              <div class="code">{{days}}</div>
              <div class="line"></div>
              <span class="code absolute">{{days}}</span>
            </div>
            <span class="text"> 天</span>
          </div>
          <div v-else class="row-2" style="margin-bottom: 0px">
            <span class="text">我已学习 </span>
            <div class="code-box">
              <div class="code">{{days}}</div>
              <div class="line"></div>
              <span class="code absolute">{{days}}</span>
            </div>
            <span class="text"> 个课程</span>
          </div>
          <div class="tail">快来和我一起学习吧~</div>
        </div>
      </div>
      <div v-if="configed" class="btn-box">
        <wx-open-launch-app
          id="launch-btn"
          appid="wx6612705805e162b2"
          @error="handleError"
          @launch="handleLaunch"
          :extinfo="extinfo"
        >
          <script type="text/wxtag-template">
            <style>
              .btn-goto-app {
                line-height: 44px;
                width: 260px;
                color: #FFFFFF;
                font-size: 16px;
                font-weight: bold;
                background: linear-gradient(270deg, #15D267 0%, #28C76D 100%);
                border-radius: 22px;
                opacity: 1;
                text-align: center;
              }
            </style>
            <div class="btn-goto-app">打开天天学拍APP</div>
          </script>
        </wx-open-launch-app>
      </div>
      <!-- <div v-else-if="isIOS" class="btn-box">
        <div class="btn-goto" @click="clickAction">打开天天学拍APP</div>
      </div> -->
      <div v-else class="btn-box">
        <!-- <div class="btn-goto">打开天天学拍APP</div> -->
      </div>
    </div>
  </div>
</template>

<script>
import ApiQuestion from '@/apis/apiQuestion.js'
const jweixin = require("weixin-js-sdk");
export default {
  data() {
    return {
      datad: false, // 获取到接口数据，展示文案
      textType: 0, // 展示文案区分：挑战赛&&参与了=1，其他=0
      configed: false,
      code: this.$route.query.code,
      days: 0,
      avatar: null,
      extinfoMap: {
        openType: 'invitation',
      },
      extinfo: "{}",
      isIOS: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
      pics: [],
      shareTitle: "",
      shareDesc: "",
      shareImgUrl: "",
    }
  },
  methods: {
    clickAction() {
      window.location.href = "https://ttxp.zxyq360.com?extmsg=" + this.extinfo
    },
    handleError(e) {
      alert('APP未安装，应用宝微下载配置后，进行下载')
      // alert(JSON.stringify(e))
    },
    handleLaunch(e) {
      // alert('handleLaunch')
      // alert(JSON.stringify(e))
    },
  },
  mounted() {
    ApiQuestion.getInvite({
      code: this.$route.query.code,
      url: location.href
    }).then(res => {
      if (res.code === 0) {
        this.avatar = res.data.user.avatar
        if (res.data.posters) {
          this.pics = res.data.posters
        }
        if (res.data.headImage) {
          this.pics.unshift(res.data.headImage)
        }
        this.extinfoMap.course = res.data.course
        this.datad = true
        if (res.data.plan != null) {
          if (res.data.joinIn) {
            this.textType = 1
            this.days = res.data.clockDays
          } else {
            this.textType = 0
            this.days = res.data.myCourses
          }
          this.extinfoMap.plan = res.data.plan
          document.title = res.data.plan.planName
        } else {
          this.textType = 0
          this.days = res.data.myCourses
          document.title = res.data.course.courseName
        }
        this.extinfo = JSON.stringify(this.extinfoMap)
        this.shareTitle = "我正在打卡《" + res.data.course.courseName + "》"
        this.shareDesc = "快来天天学拍一起打卡学习！"
        this.shareImgUrl = res.data.course.courseImage
        var config = res.data.config
        jweixin.config({
          // debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: config.appId, // 必填，公众号的唯一标识
          timestamp: config.timestamp, // 必填，生成签名的时间戳
          nonceStr: config.nonceStr, // 必填，生成签名的随机串
          signature: config.signature, // 必填，签名
          jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage"], // 必填，需要使用的JS接口列表
          openTagList: ["wx-open-launch-app"], // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
        });
        jweixin.ready((res) => {
          this.configed = true
          console.log("wx-open-launch-app已加载============>");
          jweixin.onMenuShareTimeline({
            title: this.shareTitle, // 分享标题
            link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: this.shareImgUrl, // 分享图标
          });
          jweixin.onMenuShareAppMessage({
            link: location.href,
            title: this.shareTitle, // 分享标题
            desc: this.shareDesc, // 分享描述
            imgUrl: this.shareImgUrl, // 分享图标
          });
        });
      } else {
        //
      }
    }).catch(err => {
      //
    })
  }
}
</script>

<style lang="scss" scoped>
  .match-parent {
    width: 100%;
  }
  #root_box {
    height: 100%;
    background-color: #000000;
  }
  .pic-box {
    font-size: 0; // img的5px
    width: 100%;
    height: 100%;
    overflow: scroll;
    .pic {
      width: 100%;
    }
  }
  .absolute-box {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    text-align: center;
    user-select: none;
  }
  .btn-box {
    height: 44px;
    width: 260px;
    margin: 0px auto 36px;
  }
  .btn-goto {
    line-height: 44px;
    width: 260px;
    color: #FFFFFF;
    font-size: 16px;
    font-weight: bold;
    background: linear-gradient(270deg, #15D267 0%, #28C76D 100%);
    border-radius: 22px;
    opacity: 1;
  }
  .card {
    width: 276px;
    height: 138px;
    background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 100%);
    border-radius: 12px;
    opacity: 1;
    margin: 0px auto 43px;
    position: relative;
  }
  .row-1 {
    display: flex;
    justify-content: space-between;
    padding: 6px 6px 0px 6px;
  }
  .point {
    width: 6px;
    height: 6px;
    background: #28C76D;
    box-shadow: 0px 0px 4px 0px rgba(79,254,161,1);
    opacity: 1;
    display: inline-flex;
    border-radius: 3px;
  }
  .row-2 {
    text-align: left;
    margin: 10px 16px;
    .text {
      font-size: 14px;
      font-weight: 500;
      color: #333333;
    }
    .code-box {
      display: inline-block;
      position: relative;
      // margin-left: 9px;
      .absolute  {
        position: absolute;
        left: 0px;
        right: 0px;
        top: 0px;
        bottom: 0px;
        user-select: text;
      }
      .code {
        font-size: 19px;
        font-weight: bold;
        color: #28C76D;
      }
      .line {
        position: absolute;
        left: 0px;
        right: 0px;
        height: 5px;
        bottom: 2px;
        background-color: #B9FFDB;
      }
    }
  }
  .row-3  {
    position: relative;
    margin-left: 54px;
    margin-top: 20px;
    text-align: left;
    .avatar {
      width: 44px;
      height: 44px;
      border-radius: 22px;
      background-color: #D9D9D9;
      position: absolute;
      left: -40px;
    }
    .tail {
      font-size: 12px;
      font-weight: 500;
      color: #666666;
      margin-top: 6px;
      margin-left: 16px;
    }
  }
</style>
